export default "__VITE_ASSET__qz6QJ_j4__"